module.exports = __webpack_public_path__ + "media/images/icon-arrow-right-gray-0f92ba89e5c9225a9ab73c7408824574.svg";